import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { authFetch } from '../../../utils/authFetch';

// Global reference data with no org_id of its own: the framework catalogue, for the
// knowledge base's Frameworks tab. The method/skill catalogue that used to live here died
// with the legacy assessment engine — Huginn's own skills load through skills-overview.

export const fetchFrameworks = createAsyncThunk(
  'reference/fetchFrameworks',
  async (domain = null, { rejectWithValue }) => {
    try {
      const qs = domain ? `?domain=${domain}` : '';
      const response = await authFetch(`/.netlify/functions/frameworks-list${qs}`, { method: 'GET' });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        return rejectWithValue(err.error || `HTTP ${response.status}`);
      }
      return await response.json();
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const referenceSlice = createSlice({
  name: 'reference',
  initialState: {
    frameworks: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFrameworks.fulfilled, (state, action) => {
        state.frameworks = action.payload.frameworks || [];
      })
      .addCase(fetchFrameworks.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const selectFrameworks = (state) => state.reference?.frameworks || [];
export default referenceSlice.reducer;
